import { FILE_SIZE_BUFFER_MULTIPLIER } from './billing-constants';

/**
 * Whether a file (in bytes) exceeds the configured upload limit (in MB),
 * applying Flutter's 5% tolerance buffer.
 *
 * Mirrors Flutter `scrips_core/lib/utils/file_picker.dart:51-57`:
 *
 *   double sizeInMb = sizeInBytes / (1024 * 1024);
 *   if (sizeInMb > (maxDocumentUploadLimit * 1.05)) return true;
 *
 * Flutter comment: "For display purposes, we are showing 100MB but while
 * checking we are giving buffer of 5MB. So maxDocumentUploadLimit is
 * multiplied by 1.05 to give buffer of 5MB."
 *
 * The buffer matters: a 10.4MB file with a stated 10MB limit ACCEPTS in
 * Flutter (10.4 < 10 * 1.05 = 10.5) and must accept in React.
 */
export function isFileSizeGreater(
  sizeInBytes: number,
  limitMb: number,
): boolean {
  const sizeInMb = sizeInBytes / (1024 * 1024);
  return sizeInMb > limitMb * FILE_SIZE_BUFFER_MULTIPLIER;
}
